import { useCallback, type Ref, type RefObject } from "react";

/**
 * Свой `ref` и чужой на одном узле.
 *
 * В React 19 `ref` приходит обычным свойством, и разложенные `{...props}`
 * перебили бы свой: так подсказка (`TooltipTrigger asChild`) отнимала у
 * кнопки её узел, и капля оставалась без хозяина.
 */
export function useMergedRef<T>(own: RefObject<T | null>, outer: Ref<T> | undefined) {
  return useCallback(
    (node: T | null) => {
      own.current = node;
      if (typeof outer === "function") outer(node);
      else if (outer) outer.current = node;
    },
    [own, outer],
  );
}
